import React from 'react'
import type { CategoryDetails } from 'generated/api'
import { CategoryIcons, getReshapedCategoryIcon } from 'components/domain/search/offers/loans/utils/constants'
import { Pending } from 'components/patterns/suspense/internals/types'
import { Actionable, Icon, Popover, Skeleton, Text, View } from 'reshaped/bundle'

interface Props {
	approvalText?: string
	approvalIcon?: () => JSX.Element
	categoryDetails?: CategoryDetails
}

export const RIBBON_HEIGHT = 'var(--rs-unit-x8)'

const Ribbon: React.FC<React.PropsWithChildren<Pending<Props>>> = props => {
	let approvalTxtElement
	let iconElement
	let tooltipElement
	let categoryIcon: React.FC | undefined

	if (props.pending) {
		return <Skeleton width="100%" height={RIBBON_HEIGHT} />
	} else {
		const { approvalIcon, approvalText, categoryDetails } = props
		iconElement = approvalIcon ? <Icon svg={approvalIcon} /> : null

		categoryIcon = categoryDetails && getReshapedCategoryIcon(categoryDetails.icon as CategoryIcons)
		approvalTxtElement = approvalText || null
		tooltipElement = categoryDetails && (
			<Popover>
				<Popover.Trigger>
					{attributes => (
						<Actionable attributes={attributes}>
							<Text variant="caption-1" weight="bold">
								<View direction="row" align="center" gap={1}>
									{categoryIcon && <Icon svg={categoryIcon} />}
									{categoryDetails.title}
								</View>
							</Text>
						</Actionable>
					)}
				</Popover.Trigger>
				<Popover.Content>{categoryDetails.details}</Popover.Content>
			</Popover>
		)
	}

	return (
		<View direction="row" align="center" paddingInline={4} paddingBlock={2} backgroundColor="primary">
			<Text variant="caption-1" weight="bold">
				<View direction="row" align="center" gap={1}>
					{iconElement}
					{approvalTxtElement}
				</View>
			</Text>
			<View.Item grow />
			<View direction="row" justify="end">
				{tooltipElement}
			</View>
		</View>
	)
}

export default Ribbon
